import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export async function fetchPrediction(payload) {
  const { data } = await axios.post(`${API}/predict`, payload, { timeout: 120000 });
  return data;
}

export async function askWheel(payload) {
  const { data } = await axios.post(`${API}/ask`, payload, { timeout: 60000 });
  return data;
}

export async function createShare(payload) {
  const { data } = await axios.post(`${API}/share`, payload, { timeout: 20000 });
  return data;
}

export async function fetchShare(token) {
  const { data } = await axios.get(`${API}/share/${token}`, { timeout: 20000 });
  return data;
}

export async function fetchPairPrediction(payload) {
  const { data } = await axios.post(`${API}/pair/predict`, payload, { timeout: 120000 });
  return data;
}

export async function askPairWheel(payload) {
  const { data } = await axios.post(`${API}/pair/ask`, payload, { timeout: 60000 });
  return data;
}

export async function createPairShare(payload) {
  const { data } = await axios.post(`${API}/pair/share`, payload, { timeout: 20000 });
  return data;
}

export async function fetchPairShare(token) {
  const { data } = await axios.get(`${API}/pair/share/${token}`, { timeout: 20000 });
  return data;
}
